export default __webpack_public_path__ + "assets/images/greys-082233596a5f2692b03ab41fef02e422.png";